// extracted by mini-css-extract-plugin
export var black = "logo-large-module--black--BUlN6";
export var initial = "logo-large-module--initial--9PK4C";
export var invert = "logo-large-module--invert--d8PPu";
export var mixed = "logo-large-module--mixed--D70gw";
export var white = "logo-large-module--white--PpnBS";
export var wrapper = "logo-large-module--wrapper--Rtkki";